import { createAction } from 'redux-actions'
import { LOGIN_USER, LOGOUT_USER, SET_HIGH_CONTRAST, LOGIN_USER_ERROR, HIDE_ERROR, GET_CONFIG, API_ERROR, REFRESH_ORDER} from '../constants/ActionTypes'
import { selectLang } from './RmaActions'
import { getEffectiveLang } from '../utils/LangUtils';
import Odoo from '../utils/Odoo'

// Backend code for an order past the configured return deadline (DEV-2468)
export const RMA_FORM_EXPIRED_CODE = 410

export const logUserOut = createAction(LOGOUT_USER)

export function setHighContrast(high_contrast) {
  return dispatch => {
    dispatch({
      type: SET_HIGH_CONTRAST,
      payload: high_contrast
    })
  }
}

export function logUserIn(order_name, token) {
  return (dispatch) => {
    const lang = getEffectiveLang()
    localStorage.setItem('lang', lang)
    let params = {order_name, token, lang}

    Odoo.login('form/login', params).then(session => {
      Odoo.call('form/get_config', { lang } , session.token).then(config => {
            dispatch({ type: GET_CONFIG, payload: { ...config } });
            dispatch({ type: LOGIN_USER, payload: { ...session, lang, credentials: { order_name, token } } });
            dispatch(selectLang(lang));
      }).catch(error => {
        dispatch({
          type: API_ERROR,
          message: error.message
        })
      })
    }).catch(error => {
      dispatch({
        type: LOGIN_USER_ERROR,
        // only the deadline message is meant for the customer, other login
        // failures keep the generic "order not found" text
        message: error.code === RMA_FORM_EXPIRED_CODE ? error.message : false
      })
    })
  }
}
export function hideError(){
  return dispatch => {
    dispatch({
      type: HIDE_ERROR
    })
  }
}

export function refreshConfigLang(lang) {
  return (dispatch, getState) => {
    const token = getState().auth && getState().auth.session && getState().auth.session.token
    if (!token) return


    Odoo.call('form/get_config', { lang: lang }, token)
      .then(config => {
        dispatch({
          type: GET_CONFIG,
          payload: config
        })
      })
      .catch(error => {
        dispatch({
          type: API_ERROR,
          message: error.message
        })
      })
  }
}

// Order data (carrier, product names) is translated by the backend at login time,
// so a language change has to fetch it again in the new language.
export function refreshOrderLang(lang) {
  return (dispatch, getState) => {
    const { auth, rma } = getState()
    const credentials = auth.session && auth.session.credentials
    if (!credentials || !rma.order || rma.order_lang === lang) return

    Odoo.login('form/login', { ...credentials, lang })
      .then(session => {
        // ignore a stale response when the language was switched again meanwhile
        if (getState().auth.lang !== lang) return
        dispatch({
          type: REFRESH_ORDER,
          payload: { data: session.data, lang }
        })
      })
      .catch(error => {
        dispatch({
          type: API_ERROR,
          message: error.message
        })
      })
  }
}
